<template lang="html">

<div id="buildings">

      <el-row class="headLine">
           <el-col :span="12">产业空间信息（存量商务楼宇）</el-col>

      <!-- 编辑 -->
           <el-col :span="12" style="text-align:right;">
               <a v-if="type==1" class="downLink" :href="downloadUrl" download >导入模版下载</a>
               <el-button v-if="type==1" @click="excelHandle" style="width:80px;"  size="small">导入Excel</el-button>
               <el-button @click="newList" style="width:90px;" size="small">刷新</el-button>
           </el-col>

      </el-row>

      <div class="navLine">
          <div @click="navChange(1)" :class="['navItem',{ 'act' : navAct == 1 }]">楼宇信息</div>
          <div @click="navChange(2)" :class="['navItem',{ 'act' : navAct == 2 }]">空间信息</div>
      </div>

      <BuildingList ref="buildingList" :type="type" v-if="navAct == 1" />
      <FloorList ref="floorList" :type="type" v-if="navAct == 2"/>

</div>

</template>

<script>
import BuildingList from './components/buildingList';
import FloorList from './components/floorList';
import { getBuildings } from '@/api/industryInfos';
export default {
    components:{
        BuildingList,
        FloorList
    },
    data(){
        return{
            navAct:1,
            type:0,
            downloadUrl:'',
        }
    },
    methods:{
        excelHandle(){
            this.$refs.buildingList.excelHandle();
        },
       navChange(inx){
         this.navAct = inx;
       },
       newList(){

         if(this.navAct == 1){
            this.$refs.buildingList.reList();
         }else if(this.navAct == 2){
            this.$refs.floorList.reList();
         }
       }
    },
    created(){
        var downLinks = ['/static/data/批量导入模板.xlsx'];
        this.downloadUrl = process.env.BASE_API + downLinks[0];
        console.log(this.$route.query);
        this.type = this.$route.query.type;
    }

}
</script>

<style lang="scss" scoped>

#buildings{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .downLink{
            margin-top: 15px;
            margin-right: 16px;
            font-size: 14px;
            color: #409EFF;
        }
    .navLine{
       padding-left: 20px;
       border-bottom: 1px solid #EBEEF5;
       .navItem{
           height: 54px;
           font-size: 14px;
           margin-left: 30px;
           display: inline-block;
           line-height: 54px;
           border-bottom: 2px solid white;
           cursor: pointer;
           &.act{
              color: #409EFF;
              border-color: #409EFF;
           }
       }
    }
    .seekLine{
        padding: 20px;
        padding-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 120px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 120px;
                .el-select{
                    display: block;
                }
            }
        }

    }

}

</style>

<style lang="scss">

#buildings{
    .el-input__inner{
        border-radius: 0px;
    }
    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }

}

</style>



// WEBPACK FOOTER //
// index.vue?3b1cee78